<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-row :gutter="10">
          <el-col :span="20">
            <el-form-item
              :label="$l('form_lable_process_name') || '工序名称'"
              prop="processName"
            >
              <el-input
                v-model="formData.processName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                maxlength="100"
                show-word-limit
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_lable_avg_test_time') || '测时平均'"
              prop="avgTestTime"
            >
              <el-input-number
                v-model="formData.avgTestTime"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                controls-position="right"
                style="width:100%"
                :max="99999999"
                :min="0"
                :step="0.01"
                :precision="2"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="5">
            <el-form-item
              :label="$l('form_lable_rating_factor') || '评比系数'"
              prop="ratingFactor"
            >
              <el-input-number
                v-model="formData.ratingFactor"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                controls-position="right"
                style="width:100%"
                :max="99999999"
                :min="0"
                :step="0.01"
                :precision="2"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$l('form_lable_working_hours') || '测定工时'">
              <el-input v-model="workingHours" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item
              :label="$l('form_lable_relaxation_rate') || '宽放率(百分比%)'"
              prop="relaxationRate"
            >
              <el-input-number
                v-model="formData.relaxationRate"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                controls-position="right"
                style="width:100%"
                :max="99999999"
                :min="0"
                :step="0.01"
                :precision="2"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item
              :label="$l('form_lable_std_time') || '工序标工'"
              prop="stdTime"
            >
              <el-input v-model="stdTime" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_lable_workers_number') || '作业人数'"
              prop="workersNumber"
            >
              <el-input-number
                v-model="formData.workersNumber"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                controls-position="right"
                style="width:100%"
                :max="9999999999"
                :min="0"
                :step="1"
                :precision="0"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="5">
            <el-form-item :label="$l('form_lable_uph') || 'UPH(小时产量)'">
              <el-input v-model="uph" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$l('form_lable_uph10') || '核定产量（10H)'">
              <el-input v-model="uph10" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item
              :label="$l('form_lable_output_unit') || '产量单位'"
              prop="outputUnit"
            >
              <el-input
                v-model="formData.outputUnit"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                maxlength="50"
                clearable
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item
              :label="$l('form_lable_labor_rate') || '工费率(元/H)'"
              prop="laborRate"
            >
              <el-input-number
                v-model="formData.laborRate"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                controls-position="right"
                style="width:100%"
                :max="99999999"
                :min="0"
                :step="2"
                :precision="3"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$l('form_lable_wages') || '工价(元)'">
              <el-input v-model="wages" readonly> </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-col :span="24">
          <el-form-item :label="$l('form_lable_remarks') || '备注'">
            <el-input
              v-model="formData.remarks"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              :rows="2"
              maxlength="500"
              show-word-limit
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import {
  add,
  multiply,
  multiplyRound,
  divideRound,
} from '@/libs/util.number.js'
export default {
  props: {
    data: { type: Object, default: () => {} },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {},
      rules: {
        processName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        avgTestTime: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        relaxationRate: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        outputUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        laborRate: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  watch: {
    data: {
      handler(val) {
        if (!this.formData || JSON.stringify(this.formData) === '{}') {
          this.formData = { ...val }
        }
      },
      immediate: true,
    },
  },
  computed: {
    // 测定工时 (测时平均值 * 评比系数)
    workingHours() {
      const { avgTestTime, ratingFactor } = this.formData
      return multiplyRound(avgTestTime, ratingFactor, 2)
    },
    // 工序标工(秒产量) (测定工时 * （1+宽放率）* 作业人数)
    stdTime() {
      const { workingHours, formData } = this
      const { relaxationRate, workersNumber } = formData
      return multiplyRound(
        multiply(
          workingHours,
          divideRound(add(100, relaxationRate || 0), 100, 2)
        ),
        workersNumber,
        2
      )
    },
    // UPH(小时产量)= 1小时（3600秒）/ 工序标工(秒产量) * 作业人数
    uph() {
      const { stdTime, formData } = this
      const { workersNumber } = formData
      return multiply(divideRound(3600, stdTime, 0), workersNumber || 0)
    },
    // 核定产量（10H) = UPH(小时产量) * 10
    uph10() {
      return multiply(this.uph, 10)
    },
    // 工价(元) = 工序标工(秒产量) * 工费率(元/H) / 3600秒
    wages() {
      const { stdTime, formData } = this
      const { laborRate } = formData
      return divideRound(multiply(stdTime, laborRate), 3600, 3)
    },
  },
  methods: {
    async validate() {
      return await validate.formValidate([this.$refs.form])
    },
    async getFormData(validate = true) {
      if (validate && !(await this.validate())) return
      const { formData, workingHours, stdTime, uph, uph10, wages } = this
      return { ...formData, workingHours, stdTime, uph, uph10, wages }
    },
  },
}
</script>
